module.exports = __webpack_public_path__ + "static/media/map-trifold-brand-refresh.54172d29.svg";